import React from 'react';

import { setComment } from '@r1-frontend/service-engineer-visit/actions';
import Comment from '@r1-frontend/service-engineer-visit/components/Comment';
import { useContextDispatch, useContextSelector } from '@r1-frontend/service-engineer-visit/hooks';

type TCommentContainerProps = {
    placeholder?: string,
}

const CommentContainer = ({ placeholder }: TCommentContainerProps) => {
    const { selectedComment } = useContextSelector(state => ({
        selectedComment: state.selected.comment,
    }));
    const dispatch = useContextDispatch();

    const handleInputComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        dispatch(setComment(e.target.value));
    };

    return (
        <Comment
            defaultValue={selectedComment}
            handleInputComment={handleInputComment}
            placeholder={placeholder}
        />
    );
};

export default CommentContainer;
